const columns = [
  {
    title: "地域分区",
    links: [
      { label: "法国伦理电影", href: "#france" },
      { label: "意大利伦理电影", href: "#italy" },
      { label: "西班牙伦理电影", href: "#spain" },
      { label: "德国伦理电影", href: "#germany" },
      { label: "英国伦理电影", href: "#uk" },
      { label: "其他欧洲伦理电影", href: "#other" },
    ],
  },
  {
    title: "主题与导览",
    links: [
      { label: "什么是伦理电影", href: "#concept" },
      { label: "地域图谱", href: "#regions" },
      { label: "主题母题", href: "#themes" },
      { label: "常见问答", href: "#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr] gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-film-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">欧美伦理电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              一个围绕欧洲艺术电影与道德叙事整理的内容索引，按地域与母题编排法国、意大利、西班牙、德国、英国
              以及更广阔的欧洲作品，帮助读者更快找到想看的严肃剧情片。
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="font-heading text-base font-bold text-white">{col.title}</h2>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 欧美伦理电影 · 内容仅供观影参考与文化交流
          </p>
          <p className="text-xs text-background-300">
            本站为独立内容站，不对影片资源提供任何形式的传播与下载。
          </p>
        </div>
      </div>
    </footer>
  );
}